import * as Yup from 'yup';
import { USER_ROLES } from './constants';

/**
 * Validation for the two provider fields that appear whenever a user's
 * role is set to Provider — in Create User, Add User Account and Bulk
 * Edit Account Access alike.
 *
 * Both are REQUIRED for that role: the backend rejects a provider
 * without them ("'Title' required" / "'NPI Number' required"). All
 * three forms used to declare them `nullable()` and label them
 * "(optional)", so the user only learnt the truth from a 422 rendered
 * under a label promising the opposite.
 *
 * The 10-digit NPI rule matches the providers endpoint and the app's
 * own "10-digit NPI number" placeholder copy.
 *
 * Lives on the entity because three separate features enforce the same
 * contract; a copy per form is how they drifted apart in the first
 * place.
 */
const NPI_PATTERN = /^\d{10}$/;

export const PROVIDER_NPI_LENGTH = 10;

export const buildProviderFieldsSchema = forms => ({
  // Optional even for the provider role: an empty title means no
  // credential, which the API accepts (2026-10-02).
  providerTitle: Yup.string().nullable(),
  providerNPINumber: Yup.string().when('role', {
    is: USER_ROLES.PROVIDER,
    then: schema =>
      schema
        .trim()
        .required(forms?.required || 'Required')
        .matches(
          NPI_PATTERN,
          forms?.providerNpiExactDigits || 'NPI number must be exactly 10 digits.'
        ),
    otherwise: schema => schema.nullable(),
  }),
});
